export default "__VITE_ASSET__e322bcac__"